import { Blocks, LogIn } from "lucide-react";
import { LOGIN_URL } from "./api";

/**
 * What a signed-out visitor sees instead of the gallery.
 *
 * A plain `<a>`, not a button with an onClick: signing in is a navigation to
 * Microsoft, and an anchor gets middle-click, "open in new tab" and keyboard
 * activation for free — all of which a div-with-a-handler would break.
 */
export function SignInPanel({ detail }: { detail?: string }) {
  return (
    // flex-1 claims the height <main> handed down, so the card sits in the
    // optical centre of the viewport rather than a fixed distance from the top.
    <div className="flex flex-1 items-center justify-center py-12">
      <div className="w-full max-w-sm rounded-2xl border border-ink-700/70 bg-ink-900/60 px-8 py-10 text-center backdrop-blur-sm">
        <div className="mx-auto flex size-12 items-center justify-center rounded-xl border border-ink-700 bg-ink-800">
          <Blocks size={22} className="text-ink-50" />
        </div>

        <h1 className="mt-6 text-xl font-semibold tracking-tight text-ink-50">
          Sign in to browse the blocks
        </h1>
        <p className="mt-2.5 text-sm leading-relaxed text-ink-400">
          The catalog is internal. Sign in with your Qure account to see the registry.
        </p>

        <a
          href={LOGIN_URL}
          className="mt-7 flex w-full items-center justify-center gap-2 rounded-lg border border-ink-700 bg-ink-800 px-4 py-2.5 text-sm font-medium text-ink-50 transition-colors hover:border-ink-400"
        >
          <LogIn size={15} />
          Sign in with Microsoft
        </a>

        {detail && (
          <p className="mt-4 text-xs leading-relaxed text-ink-400">Last attempt: {detail}</p>
        )}
      </div>
    </div>
  );
}
